import { createSelector } from "reselect"

export const authSelector = state => state.auth || {}

export const userInitializedSelector = createSelector(authSelector, auth => !!auth.initialized)
